import { getKeys } from '@shared/helpers/object.helpers';
import { IElementID } from '@shared/models/project.model';
import { Page } from './ui.model';

const pageValues: ReadonlySet<string> = new Set(Object.values(Page));

const isPage = (page: string): page is Page => pageValues.has(page);

/**
 * Merge newly observed element ids into the existing map.
 * @returns The merged map, or `undefined` when every incoming {@link IElementID} is already present
 */
export const mergeObservedElementIds = (
  current: Record<IElementID, boolean>,
  incoming: Record<IElementID, boolean>,
): Record<IElementID, boolean> | undefined => {
  const hasNewId = getKeys(incoming, false).some((id) => !current[id]);
  if (!hasNewId) return undefined;
  return { ...current, ...incoming };
};

/**
 * Convert a URL page segment to {@link Page}.
 * @param page - Raw page segment from the URL
 * @returns Resolved {@link Page}
 */
export const stringToPage = (page?: string): Page => {
  if (page === undefined || page === '') return Page.Design;
  if (page === 'import') return Page.Import;
  return isPage(page) ? page : Page.Elements;
};
